import { Entry } from 'contentful';
import Image from 'next/image';
import { Integration } from 'repos/b12Page';

type Props = {
  title: string;
  subtitle: string;
  integrations: Entry<Integration>[];
};

export default function IntegrationsBlock({
  title,
  subtitle,
  integrations,
}: Props) {
  return (
    <section className="py-24">
      <div className="mx-auto mb-16 max-w-7xl px-6">
        <h2 className="text-r-3xl text-center font-bold">{title}</h2>
        <p className="text-r-lg m-auto mt-8 max-w-3xl  text-center">
          {subtitle}
        </p>
      </div>
      <div className="mx-auto flex flex-col items-center justify-center gap-8 px-6 md:flex-row md:gap-32">
        {integrations.map((integration) => (
          <Image
            key={integration.sys.id}
            src={`https:${integration.fields.image.fields.file.url}`}
            alt={integration.fields.title}
            width={
              (integration.fields.image.fields.file.details.image?.width || 0) /
              1.5
            }
            height={
              (integration.fields.image.fields.file.details.image?.height ||
                0) / 1.5
            }
          />
        ))}
      </div>
    </section>
  );
}
